import { useMutation } from '@tanstack/react-query'
import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function useReactQueryMutation({
  mutationFn,
  mutationKey,
  showOnSuccessMessage = false,
  onSuccessMessage,
  onSuccess,
  onError,
  onMutate, // new optional lifecycle hook for optimistic updates
}) {
  const { t } = useTranslation()
  onSuccessMessage = onSuccessMessage ?? t('success', 'Success!')
  const showStatusOverlay = useStatusOverlay()

  const mutation = useMutation({
    mutationKey,
    mutationFn,
    onMutate, // forward to react-query so callers can optimistically update cache
    onSuccess: (data, variables, context) => {
      if (showOnSuccessMessage) {
        showStatusOverlay({ message: onSuccessMessage, type: 'success' })
      }
      onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      const errorCode = error?.response?.status
      if (errorCode >= 500) {
        showStatusOverlay({
          message: t('error.server', 'The server encountered an error and has been reported. Try again.'),
          type: 'error',
        })
      } else {
        showStatusOverlay({ message: t('error.generic', 'Oops. Something went wrong.'), type: 'error' })
        onError?.(error, variables, context)
      }
    },
  })

  return { mutation, data: mutation?.data?.data }
}
